// Central content source of truth (marketing). Aligned to TWORAY master documentation.

export const CONTACT = {
  email: "hello@tworay.co.uk",
  phone: "+44 7947 477 251",
  website: "www.tworay.co.uk",
  privacyEmail: "privacy@tworay.co.uk",
};

export const COMPANY = {
  name: "TWORAY Ltd",
  jurisdiction: "England & Wales",
  regNumber: "17400525",
  registeredOffice: "United Kingdom",
  vatNumber: "",
  icoReg: "",
  brandTop: "TECHNOLOGY ADVISORY & CYBER SECURITY",
  brandTagline: "CLARITY • SECURITY • GROWTH",
  positioning: "Independent technology and cyber security advisory for growing organisations.",
  principle: "Advice first. Implementation where it adds value and is explicitly scoped.",
};

export const PILLARS = [
  {
    key: "technology",
    num: "01",
    title: "Technology Advisory",
    summary:
      "Technology strategy, Microsoft 365, architecture, suppliers, platforms and technology decision-making.",
    points: ["Technology strategy", "Microsoft 365", "Architecture & platforms", "Supplier decisions"],
  },
  {
    key: "cyber",
    num: "02",
    title: "Cyber Security Advisory",
    summary:
      "Security posture, Cyber Essentials readiness, ISO 27001 readiness, identity, endpoint security and proportionate risk reduction.",
    points: ["Cyber Essentials readiness", "ISO 27001 readiness", "Identity & endpoint", "Proportionate risk reduction"],
  },
  {
    key: "governance",
    num: "03",
    title: "Governance & Resilience",
    summary:
      "Information governance, risk, business continuity, resilience, policies and organisational controls.",
    points: ["Information governance", "Business continuity", "Policies & controls", "Risk & resilience"],
  },
  {
    key: "transformation",
    num: "04",
    title: "Transformation & Enablement",
    summary:
      "Microsoft 365 implementation, Teams, SharePoint, email migration, secure foundations and implementation support where scoped.",
    points: ["Microsoft 365 & Teams", "SharePoint", "Email migration", "Secure foundations"],
  },
];

// The TWORAY advisory framework — four core stages, with Discover (before) and Assure (after).
export const FRAMEWORK = {
  discover: {
    title: "Discover",
    desc: "Pre-engagement intake: discovery questionnaire, initial consultation, business context, objectives, immediate concerns and preliminary scope.",
  },
  core: [
    { num: "01", title: "Assess", desc: "Understand the organisation, environment, controls, risks, dependencies and business requirements." },
    { num: "02", title: "Advise", desc: "Translate findings into independent, proportionate recommendations aligned to commercial priorities." },
    { num: "03", title: "Plan", desc: "Prioritise recommendations into a practical roadmap with clear actions, sequencing, ownership and investment considerations." },
    { num: "04", title: "Enable", desc: "Support implementation, supplier coordination, configuration and organisational change where explicitly included within the agreed scope." },
  ],
  assure: {
    title: "Assure",
    desc: "Ongoing advisory and retainer support after the primary engagement.",
  },
};

export const PROBLEMS = [
  "Technology decisions made without independent advice",
  "Unclear or growing cyber security risk",
  "Pressure from customer due diligence and compliance",
  "Microsoft 365 set up without secure foundations",
  "Overwhelming technical reports with no practical roadmap",
  "Over-reliance on product-led IT providers",
];

export const OUTCOMES = [
  "A clearer understanding of your technology and cyber risk",
  "A prioritised remediation roadmap",
  "A stronger Microsoft 365 security baseline",
  "Improved governance and accountability",
  "Increased readiness for customer due diligence",
  "A practical pathway towards Cyber Essentials or ISO 27001 readiness",
];

export const WHY_TWORAY = [
  { num: "01", title: "Independent Advice", desc: "Recommendations driven by client needs rather than product sales." },
  { num: "02", title: "Business First", desc: "Technology decisions connected to commercial priorities." },
  { num: "03", title: "Practical Security", desc: "Proportionate controls rather than unnecessary complexity." },
  { num: "04", title: "Clear Roadmaps", desc: "Prioritised actions rather than overwhelming technical reports." },
  { num: "05", title: "Flexible Delivery", desc: "Advisory first, with implementation support where appropriate." },
  { num: "06", title: "Clear Communication", desc: "Executive-level clarity without unnecessary jargon." },
];

export const TRUST_CUES = [
  "Independent advisory",
  "Advice-first approach",
  "Cyber Essentials & ISO 27001 readiness",
  "Direct expert involvement",
];

// Discovery Call form option sets
export const SERVICE_INTERESTS = [
  "Technology Advisory",
  "Cyber Security Advisory",
  "Microsoft 365",
  "Cyber Essentials Readiness",
  "ISO 27001 Readiness",
  "Governance & Information Management",
  "Business Continuity & Resilience",
  "SharePoint / Collaboration",
  "Technology Transformation",
  "Secure Business Foundation",
  "Not sure — I need guidance",
  "Other",
];

export const COMPANY_SIZES = [
  "1–10",
  "11–50",
  "51–200",
  "201–500",
  "500+",
];

export const PACKAGE_INTERESTS = [
  "Foundation",
  "Business Ready",
  "Scale-Up Pro",
];

export const QUERY_TOPICS = [
  "Technology Advisory",
  "Cyber Security",
  "Microsoft 365",
  "Cyber Essentials",
  "ISO 27001",
  "Governance & Resilience",
  "Business Continuity",
  "SharePoint / Information Governance",
  "Packages & Pricing",
  "Other",
];

export const CONTACT_REASONS = [
  "Growth or scaling",
  "Specific technology issue",
  "Cyber security concern",
  "Customer or supplier requirement",
  "Cyber Essentials",
  "ISO 27001",
  "Business continuity / resilience",
  "Microsoft 365 concern",
  "Governance / compliance requirement",
  "Technology change or project",
  "Need independent advice",
  "Other",
];

export const TIMING_OPTIONS = [
  "As soon as possible",
  "Within 30 days",
  "Within 1–3 months",
  "Within 3–6 months",
  "Exploring options / no fixed deadline",
];

export const LEAD_SOURCES = [
  "LinkedIn",
  "Google / Search Engine",
  "Referral / Recommendation",
  "Business Partner",
  "Networking / Event",
  "Ray",
  "Existing Contact",
  "Other",
];

export const PREFERRED_CONTACT = [
  "Email",
  "Telephone",
  "Microsoft Teams / Video Call",
  "No preference",
];

